/* eslint-disable css-modules/no-unused-class  */
import { FC, useEffect, useState } from 'react';
import { ContentCardProps, Loader } from 'learning-panel-components';
import convertVideosToBanner from '@services/convertVideosToBanner';
import { useSelector } from 'react-redux';
import { translate } from 'translations';
import { selectIsLeanUser, selectToken } from '@redux/slices/userSlice';
import { useGetVideoTutorials } from '@queries/core/videoTutorials';
import { coreService } from 'network-utils';
import convertVideosToContentCard from '@services/convertVideosToContentCard';
import CardsGalleryContainer from '@components/cardsGallery/cardsGalleryContainer';
import VideoTutorialBanner, { VideoTutorialBannerProps } from './videoTutorialsBanner/videoTutorialsBanner';
import styles from './videoTutorialsPage.module.scss';

interface VideoTutorialsPageProps {
    setVideoTutorialUuid: Function;
    fullWidth?: boolean;
}

const VideoTutorialsPageContainer: FC<VideoTutorialsPageProps> = ({
    setVideoTutorialUuid,
    fullWidth
}: VideoTutorialsPageProps) => {
    const token = useSelector(selectToken);
    const isLeanUser = useSelector(selectIsLeanUser);
    const { data, isLoading } = useGetVideoTutorials(token);
    const [videosWiki, setVideosWiki] = useState<ContentCardProps[]>([]);
    const [videosMonthly, setVideosMonthly] = useState<ContentCardProps[]>([]);
    const [videoBanner, setVideoBanner] = useState<VideoTutorialBannerProps>();

    useEffect(() => {
        if (!data) return;
        if ((data as any).success === false) return;

        const tempWiki = data.wiki.map((wikiVideo: coreService.VideoTutorialData) =>
            convertVideosToContentCard(wikiVideo, setVideoTutorialUuid)
        );
        const tempMonthly = data.monthly.map((wikiVideo: coreService.VideoTutorialData) =>
            convertVideosToContentCard(wikiVideo, setVideoTutorialUuid)
        );

        if (data.monthly.length > 0) {
            const videoBanner = convertVideosToBanner(data.monthly[0], setVideoTutorialUuid);
            setVideoBanner(videoBanner);
        }

        setVideosWiki(tempWiki);
        setVideosMonthly(tempMonthly);
    }, [data]);

    return (
        <div className={styles['video-tutorials']}>
            {isLoading ? (
                <Loader showBackground={false} />
            ) : (
                <>
                    {videoBanner && <VideoTutorialBanner {...videoBanner} />}
                    <div className={fullWidth ? styles.container : styles['no-full-container']}>
                        <CardsGalleryContainer
                            data={videosMonthly}
                            columns={2}
                            rows={2}
                            title={translate('CheckmarxInReview')}
                            infoDescription={translate('CheckmarxInReviewVideosToWatch')}
                            noFullWidthColumn={3}
                            fullWidth={fullWidth}
                        />
                        <div className={styles.space}></div>
                        <CardsGalleryContainer
                            data={videosWiki}
                            columns={2}
                            rows={2}
                            fullWidth={fullWidth}
                            title={translate('BonusTopics')}
                            infoDescription={translate('BonusTopicsVideosToWatch')}
                            noFullWidthColumn={3}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
export default VideoTutorialsPageContainer;
